'use es6';

import debounce from 'hs-lodash/debounce';
import { postExternalApiEvent } from '../external-api-events/postExternalApiEvent';
import { INPUT_STAGING } from '../external-api-events/constants/externalApiEventTypes';
import { INPUT_STAGING_EVENT_DEBOUNCE_MS } from '../pubsub/constants/inputStagingEventConstant';
export const inputStagingEvent = (message, isEmptyInput = false) => {
  postExternalApiEvent({
    eventType: INPUT_STAGING,
    payload: {
      visitorMessageData: message,
      isEmptyInput
    }
  });
};
export const debouncedStagingEvent = debounce(inputStagingEvent, INPUT_STAGING_EVENT_DEBOUNCE_MS);